import { ITelephonyConfiguration } from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IToggleOutboundCallingVariables {
	outboundCallingDisabled: boolean;
	phoneNumberId: string;
}

interface IOptions {
	onError?: (error: Error, variables: IToggleOutboundCallingVariables) => void;
	onMutate?: (variables: IToggleOutboundCallingVariables) => void;
	onSettled?: (variables: IToggleOutboundCallingVariables) => void;
	onSuccess?: (phoneNumber: ITelephonyConfiguration, variables: IToggleOutboundCallingVariables) => void;
}

export const useToggleOutboundCallingMutation = ({ onError, onMutate, onSettled, onSuccess }: IOptions = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ outboundCallingDisabled, phoneNumberId }: IToggleOutboundCallingVariables) => {
			const result = await userSession.webServiceHelper.callWebServiceAsync<ITelephonyConfiguration>(
				`aida/userPhoneNumbers/${phoneNumberId}?outboundCallingDisabled=${outboundCallingDisabled}`,
				'PATCH'
			);

			if (!result?.success || !result.value) {
				throw new Error(result?.systemMessage || 'Failed to update outbound calling');
			}

			return result.value;
		},
		onError: (error, variables) => onError?.(error, variables),
		onMutate: variables => onMutate?.(variables),
		onSettled: (_data, _error, variables) => onSettled?.(variables),
		onSuccess: (phoneNumber, variables) => onSuccess?.(phoneNumber, variables),
	});
};
